import { properties } from "../modules/stats/core/mappings";
import { kpis } from "./kpis";
import { sources } from "./constants";
import moment from "moment-timezone";
import _ from "lodash";
const configs = {
  startDateRef: moment("2019-01-01").startOf("day"),
  setDimensions: (kpi = {}, client_id, actions = []) => {
    let actionNatures = actions.map(v => {
      return { id: v.action_nature, value: v.action_nature };
    });
    actionNatures.push({ id: "Autre", value: "Autre" });
    let actionTypes = actions.map(v => {
      return { id: v.action_type, value: v.action_type };
    });
    actionTypes.push({ id: "Autre", value: "Autre" });

    actionNatures = _.uniqBy(actionNatures, v => v.value);
    actionTypes = _.uniqBy(actionTypes, v => v.value);

    configs.dimensions = [
      {
        dimension_id: 1,
        label: "Globale",
        id: "globale"
      },
      {
        dimension_id: 3,
        label: "Secteur",
        id: "sector_id"
      },
      {
        dimension_id: 4,
        label: "PDC",
        id: "pdc_id"
      },
      {
        dimension_id: 5,
        label: "Référence",
        id: "product_ean",
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT);
        }
      },
      {
        dimension_id: 6,
        label: "Enseigne",
        id: "retailer_id"
      },
      {
        dimension_id: 7,
        label: "Emplacement",
        id: "locationType"
      },
      {
        dimension_id: 8,
        label: "Famille",
        id: "family",
        display: () => {
          return (
            (kpi.source &&
              (sources.equals(kpi.source, sources.PRODUCT) ||
                sources.equals(kpi.source, sources.FAMILY) ||
                sources.equals(kpi.source, sources.BRAND))) ||
            kpi.id === 18
          );
        }
      },
      {
        dimension_id: 9,
        label: "Marque",
        id: "brand",
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT) || sources.equals(kpi.source, sources.BRAND);
        }
      },
      {
        dimension_id: 10,
        label: "Segment",
        id: "product_segments",
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT);
        }
      },
      {
        dimension_id: 11,
        label: kpi.id === kpis.MEA ? "Type de MEA" : "Propriété",
        id: "product_range_properties",
        label_mapping: properties,
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT) && kpi.id !== kpis.PLV;
        }
      },
      {
        dimension_id: 12,
        label: "Strate",
        id: "strate",
        display: () => {
          return (
            kpi.source &&
            (sources.equals(kpi.source, sources.PRODUCT) ||
              sources.equals(kpi.source, sources.FAMILY) ||
              sources.equals(kpi.source, sources.BRAND))
          );
        }
      },
      {
        dimension_id: 13,
        label: "Réseau",
        id: "network_label"
      },
      {
        dimension_id: 14,
        label: "Centrales nationales",
        id: "national"
      },
      {
        dimension_id: 15,
        label: "Centrales régionales",
        id: "regional"
      },
      {
        dimension_id: 16,
        label: "Couvert",
        id: "",
        active: false
      },
      {
        dimension_id: 17,
        label: "Typologie ",
        id: "typology"
      },
      {
        dimension_id: 18,
        label: "Ranking",
        id: "product_ranking",
        type: Number,
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT);
        }
      },
      {
        dimension_id: 19,
        label: "Top39",
        id: "product_top_39",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }],
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT);
        }
      },
      {
        dimension_id: 20,
        label: "20/80",
        id: "",
        active: false
      },
      {
        dimension_id: 21,
        label: "Entrepôt",
        id: "",
        active: false
      },
      {
        dimension_id: 22,
        label: "Réimplanté",
        id: "reimplante",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }]
      },
      {
        dimension_id: 23,
        label: "Recadré",
        id: "recadre",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }]
      },
      {
        dimension_id: 24,
        label: "Type de DN",
        id: "type_dn",
        data: [
          { id: "with_rupt", value: "Avec rupture" },
          { id: "without_rupt", value: "Sans rupture" },
          { id: "rupt_only", value: "Rupture uniquement" }
        ],
        display: (_kpi = {}, filters = {}) => {
          const { presence = {} } = filters;
          const { values = [] } = presence;
          return values.indexOf("miss") === -1 && (kpi.id === 10 || kpi.id === 11);
        },
        mode: "default"
      },
      {
        dimension_id: 25,
        label: "Commande",
        id: "",
        active: false
      },
      {
        dimension_id: 26,
        label: "Fréquence",
        id: "pdc_frequency"
      },
      {
        dimension_id: 27,
        label: "Sectorisé",
        id: "",
        active: false
      },
      {
        dimension_id: 28,
        label: "Présence",
        id: "",
        display: () => {
          return kpi.id === 10 || kpi.id === 11;
        }
      },
      {
        dimension_id: 29,
        label: "Emplacement",
        id: "location",
        active: true
      },
      {
        dimension_id: 30,
        label: "Utilisateur",
        id: "user_email",
        active: true
      },
      {
        dimension_id: 31,
        label: "Strate",
        id: "strates",
        display: () => {
          return kpi.id === kpis.COUVERTURE;
        }
      },
      /*{
        dimension_id: 32,
        label: "Ranking PDC",
        id: "pdc_ranking",
        display: () => {
          return client_id === 5
        }
      },*/
      {
        dimension_id: 32,
        label: "Top 450",
        id: "top_450",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }]
      },
      {
        dimension_id: 33,
        label: "CIP",
        id: "pdc_cip",
        display: () => {
          return client_id === 17;
        }
      },
      {
        dimension_id: 34,
        label: "Club 100",
        id: "pdc_club_100",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }]
      },
      {
        dimension_id: 35,
        label: "Groupement",
        id: "pdc_group_label"
      },
      {
        dimension_id: 36,
        label: "DR",
        id: "pdc_dr"
      },
      {
        dimension_id: 37,
        label: "DP",
        id: "pdc_dp"
      },
      // {
      //   dimension_id: 37,
      //   label: "DP",
      //   id: "pdc_dp"
      // },
      {
        dimension_id: 38,
        label: "Action nature",
        id: "action_nature",
        data: actionNatures
      },
      {
        dimension_id: 39,
        label: "Action type",
        id: "action_type",
        data: actionTypes
      },
      {
        dimension_id: 40,
        label: "PDC Statut",
        id: "pdc_statut"
      },
      {
        //type merch
        dimension_id: 41,
        label: "Type (Merch)",
        id: "merch_type",
        display: () => {
          return kpi.id === kpis.MEA || kpi.id === kpis.PLV;
        }
      },
      {
        dimension_id: 102,
        label: kpi.long_label,
        id: "kpi_value_label",
        display: (_kpi = {}) => {
          return kpi.id === _kpi.id && (kpi.format === "radio" || kpi.format === "checkbox");
        },
        //mode: kpi.format === "radio" ? "default" : "default",
        allowClear: true, //kpi.format === "checkbox",
        //defaultValue: ["0"],
        active: true
      },
      {
        dimension_id: 100,
        label: "Type de gain",
        id: "type_gain",
        data: [
          //{ id: "global", value: "Global" },
          { id: "e2v", value: "Entre deux visites" },
          { id: "alv", value: "A la visite" },
          { id: "e1d", value: "Entre la première et la dernière visite" }
        ],
        display: () => {
          return (
            kpi.id === kpis.GAIN_FACING ||
            kpi.id === kpis.GAIN_REFERENCES ||
            kpi.id === kpis.GAIN_DN ||
            kpi.id === kpis.GAIN_PDL
          );
        },
        mode: "default",
        allowClear: false,
        defaultValue: ["e1d"],
        active: true
      },
      {
        dimension_id: 101,
        label: "Présence",
        id: "presence",
        data: [{ id: "pres", value: "Présent" }, { id: "miss", value: "Manquant" }],
        display: () => {
          return kpi.id === 10 || kpi.id === 11;
        },
        mode: "default",
        allowClear: true,
        active: true
      } /*
      {
        dimension_id: 102,
        label: kpi.long_label,
        id: "kpi_value_id_" + kpi.id,
        data: () => {
          kpi.values = kpi.values || [];
          const data = [];
          for (let i = 0; i < kpi.values.length; i++) {
            const value = kpi.values[i];
            if (value.indexOf("@") === -1) {
              data.push({ id: i + "", value });
            }
          }
          return data;
        },
        display: (_kpi = {}) => {
          return kpi.id === _kpi.id && (kpi.format === "radio" || kpi.format === "checkbox");
        },
        //mode: kpi.format === "radio" ? "default" : "default",
        allowClear: true, //kpi.format === "checkbox",
        //defaultValue: ["0"],
        active: true
      },*/,
      {
        dimension_id: 103,
        label: "Volume",
        id: "product_volume",
        type: Number,
        display: () => {
          return client_id === 1 && sources.equals(kpi.source, sources.PRODUCT);
        }
      },
      {
        dimension_id: 104,
        label: "Incontournable",
        id: "product_incontournables",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }],
        display: () => {
          return client_id === 17 && sources.equals(kpi.source, sources.PRODUCT);
        }
      },
      {
        dimension_id: 105,
        label: "Catégorie",
        id: "category",
        display: () => {
          return (
            (kpi.source && sources.equals(kpi.source, sources.PRODUCT)) ||
            sources.equals(kpi.source, sources.BRAND) ||
            sources.equals(kpi.source, sources.FAMILY) ||
            sources.equals(kpi.source, sources.CATEGORY)
          );
        }
      },
      {
        dimension_id: 106,
        label: "Questionnaires actifs uniquement",
        id: "survey_actives_only",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }]
      },
      {
        dimension_id: 107,
        label: "Dernière secto uniquement",
        id: "last_secto_only",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }]
      },
      {
        dimension_id: 108,
        label: "Gain",
        id: "gain_direction",
        data: [{ id: "gain", value: "Gain" }, { id: "loss", value: "Perte" }],
        display: () => {
          return kpi.calculation_type === "Variation";
        },
        mode: "default",
        allowClear: true,
        active: true
      },
      {
        dimension_id: 109,
        label: "Questionnaire",
        id: "survey_label",
        display: () => {
          return true;
        }
      },
      {
        dimension_id: 110,
        label: "Action",
        id: "statement_id",
        mode: "default",
        allowClear: true,
        display: () => {
          return !sources.equals(kpi.source, sources.PDC) && !sources.equals(kpi.source, sources.VISIT);
        }
      },
      {
        dimension_id: 111,
        label: "Début de visite",
        id: "p_visit_statement",
        data: [
          //{ id: "global", value: "Global" },
          { id: "start", value: "Début de visite" },
          { id: "end", value: "Fin de visite" }
        ],
        display: () => {
          return true;
          return kpi.id === kpis.DN || kpi.id === kpis.PDL_BRAND || kpi.id === kpis.PDL;
        },
        mode: "default",
        allowClear: false,
        defaultValue: ["end"],
        active: true
      },
      {
        dimension_id: 112,
        label: "Début de visite",
        id: "p1_visit_statement",
        data: [
          //{ id: "global", value: "Global" },
          { id: "start", value: "Début de visite" },
          { id: "end", value: "Fin de visite" }
        ],
        display: () => {
          return true;
          return kpi.id === kpis.DN || kpi.id === kpis.PDL_BRAND || kpi.id === kpis.PDL;
        },
        mode: "default",
        allowClear: false,
        defaultValue: ["end"],
        active: true
      },
      {
        dimension_id: 113,
        label: "Visite",
        id: "p_visit_target",
        title: "Période 1",
        data: [
          //{ id: "global", value: "Global" },
          { id: "first", value: "Première visite" },
          { id: "last", value: "Dernière visite" }
        ],
        display: () => {
          return true;
          return kpi.id === kpis.DN || kpi.id === kpis.PDL_BRAND || kpi.id === kpis.PDL;
        },
        mode: "default",
        allowClear: false,
        defaultValue: ["last"],
        active: true
      },
      {
        dimension_id: 114,
        label: "Visite",
        id: "p1_visit_target",
        title: "Période 2",
        data: [
          //{ id: "global", value: "Global" },
          { id: "first", value: "Première visite" },
          { id: "last", value: "Dernière visite" }
        ],
        display: () => {
          return true;
          return kpi.id === kpis.DN || kpi.id === kpis.PDL_BRAND || kpi.id === kpis.PDL;
        },
        mode: "default",
        allowClear: false,
        defaultValue: ["last"],
        active: true
      },
      {
        dimension_id: 115,
        label: "Comparaison",
        id: "gain_compare_type",
        title: "Type de comparaison",
        data: [{ id: "all", value: "Toutes les données" }, { id: "common", value: "PDCs Identiques" }],
        display: () => {
          return true;
          return kpi.id === kpis.DN || kpi.id === kpis.PDL_BRAND || kpi.id === kpis.PDL || kpi.id === kpis.VISITES;
        },
        mode: "default",
        allowClear: false,
        defaultValue: ["all"],
        active: true
      },
      {
        dimension_id: 116,
        label: "Top15",
        id: "product_top_15",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }],
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT);
        }
      },
      {
        dimension_id: 117,
        label: "Top21",
        id: "product_top_21",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }],
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT);
        }
      },
      {
        dimension_id: 118,
        label: "Code SAP",
        id: "pdc_code_sap"
      },
      {
        dimension_id: 119,
        label: "EO PILES",
        id: "pdc_eo_piles"
      },
      {
        dimension_id: 120,
        label: "Top45",
        id: "product_top_45",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }],
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT);
        }
      },
      {
        dimension_id: 121,
        label: "Top50",
        id: "product_top_50",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }],
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT);
        }
      },
      {
        dimension_id: 122,
        label: "Top31",
        id: "product_top_31",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }],
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT);
        }
      },
      {
        dimension_id: 123,
        label: "Présence",
        id: "kpi_presence",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }],
        display: () => {
          return kpi.id === kpis.ETIQUETTE;
        }
      },
      {
        dimension_id: 124,
        label: "Top20",
        id: "product_top_20",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }],
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT);
        }
      }, 
      {
        dimension_id: 125,
        label: "Top25",
        id: "product_top_25",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }],
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT);
        }
      }, 
      {
        dimension_id: 126,
        label: "Top30",
        id: "product_top_30",
        type: Boolean,
        data: [{ id: "1", value: "1" }, { id: "0", value: "0" }],
        display: () => {
          return sources.equals(kpi.source, sources.PRODUCT);
        }
      },
    ];
  },
  dimensions: [],
  /*,
	kpiIds: [
		kpis.FACING,
		kpis.FACING_MOYEN,
		kpis.GAIN_FACING,
		kpis.REFERENCES,
		kpis.GAIN_REFERENCES,
		kpis.DN,
		kpis.GAIN_DN,
		kpis.RUPTURE,
		kpis.TAUX_RUPTURE,
		kpis.POSITION,
		kpis.POSITION_MARQUE,
		kpis.PRIX,
		kpis.LINEAIRE,
		kpis.PDL,
		kpis.GAIN_PDL,
		kpis.VISITES,
		kpis.PRES,
		kpis.COUVERTURE,
	]*/ kpisDisplayOrder: [
    kpis.DN,
    kpis.GAIN_DN,
    kpis.RUPTURE,
    kpis.TAUX_RUPTURE,
    kpis.REFERENCES,
    kpis.GAIN_REFERENCES,
    kpis.FACING,
    kpis.FACING_MOYEN,
    kpis.GAIN_FACING,
    kpis.LINEAIRE,
    kpis.PDL,
    kpis.PRIX,
    kpis.COUVERTURE
  ],
  kpiToFilter: {
    [kpis.FACING_MOYEN]: kpis.FACING,
    [kpis.GAIN_FACING]: kpis.FACING,
    [kpis.REFERENCES]: kpis.FACING,
    [kpis.GAIN_REFERENCES]: kpis.FACING,
    [kpis.DN]: kpis.FACING,
    [kpis.GAIN_DN]: kpis.FACING,
    [kpis.RUPTURE]: kpis.FACING,
    [kpis.TAUX_RUPTURE]: kpis.FACING,
    [kpis.LINEAIRE]: kpis.FACING,
    [kpis.PDL]: kpis.FACING,
    [kpis.GAIN_PDL]: kpis.FACING,
    [kpis.COUVERTURE]: kpis.VISITES
    //18: 17,
    //19: 17,
  }
};

export default configs;



// WEBPACK FOOTER //
// src/configs/stats.js